"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacesServiceStatusTypes = exports.Handler = void 0;
var Handler;
(function (Handler) {
    Handler["geocode"] = "geocode";
    Handler["places"] = "places";
})(Handler = exports.Handler || (exports.Handler = {}));
// Status is dictated due to https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesServiceStatus
var PlacesServiceStatusTypes;
(function (PlacesServiceStatusTypes) {
    PlacesServiceStatusTypes["Ok"] = "OK";
    PlacesServiceStatusTypes["InvalidRequest"] = "INVALID_REQUEST";
    PlacesServiceStatusTypes["NotFound"] = "NOT_FOUND";
    PlacesServiceStatusTypes["OverQueryLimit"] = "OVER_QUERY_LIMIT";
    PlacesServiceStatusTypes["RequestDenied"] = "REQUEST_DENIED";
    PlacesServiceStatusTypes["UnknownError"] = "UNKNOWN_ERROR";
    PlacesServiceStatusTypes["ZeroResults"] = "ZERO_RESULTS";
})(PlacesServiceStatusTypes = exports.PlacesServiceStatusTypes || (exports.PlacesServiceStatusTypes = {}));
//# sourceMappingURL=types.js.map